import script from "./App-v2.vue?vue&type=script&lang=ts&setup=true"
export * from "./App-v2.vue?vue&type=script&lang=ts&setup=true"

import "./App-v2.vue?vue&type=style&index=0&id=7ff8c4e8&lang=css"

const __exports__ = script;

export default __exports__